import { useQuery } from '@tanstack/react-query';
import { SelectOption } from 'components/forms/Select';
import { sdClient } from 'contexts/SDKClientContext';
import { useMemo } from 'react';

export function useIndustryTypes() {
    const { data } = useQuery({
        queryKey: ['industry'],

        queryFn: async () => sdClient.getIndustries({ pageLimit: 1000 }),
    });

    const industryOptions = useMemo<SelectOption[] | undefined>(
        () =>
            data?.Result.map<SelectOption>((value) => ({
                title: value.Name,
                value: value.Id.toString(),
            })),
        [data]
    );

    return industryOptions;
}
